export default __webpack_public_path__ + "static/media/face_off_intro.ad8d8bf1.mp3";